import { fetchPostUtility, IFetchResponse } from '@/utilities/fetch';

export async function addressSearchRequest(keyword: string): Promise<IFetchResponse> {
    return fetchPostUtility('/address-search', { keyword });
}
